<template>
  <div class="live-create-prize">
    <!-- 创建奖品 -->
    <vh-dialog
      :title="`${title}${$t('host.k_577001')}`"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      :modal="false"
      custom-class="create-prize"
      :close-on-click-modal="false"
      width="480px"
    >
      <vh-form
        :model="prizeForm"
        :rules="rules"
        ref="prizeForm"
        label-width="92px"
        onsubmit="return false;"
      >
        <vh-form-item :label="$t('host.k_577002')" required>
          <vh-radio-group v-model="prizeForm.award_type" @change="changeType" class="coupon_method">
            <vh-radio :label="0">{{ $t('host.k_577003') }}</vh-radio>
            <vh-radio :label="1">{{ $t('host.k_577004') }}</vh-radio>
            <vh-radio :label="3">{{ $t('host.k_577005') }}</vh-radio>
          </vh-radio-group>
          <div class="couponInfo" v-if="prizeForm.award_type == 1 && !prizeForm.coupon_id">
            <vh-button
              type="default"
              size="medium"
              round
              plain
              @click="choseCoupon"
              v-preventReClick
            >
              {{ $t('host.k_577006') }}
            </vh-button>
          </div>
        </vh-form-item>
        <vh-form-item
          :label="$t('host.k_577007')"
          required
          v-if="prizeForm.award_type == 1 && prizeForm.coupon_id"
        >
          <div class="couponInfo">
            <div class="coupon">{{ prizeForm.coupon_name }}</div>
            <div class="highLight" @click="choseCoupon">{{ $t('host.k_577008') }}</div>
          </div>
        </vh-form-item>
        <vh-form-item
          :label="$t('host.k_577009')"
          prop="third_lottery_id"
          v-if="prizeForm.award_type === 3"
        >
          <vh-input
            v-model.trim="prizeForm.third_lottery_id"
            :maxlength="50"
            autocomplete="off"
            show-word-limit
          ></vh-input>
        </vh-form-item>
        <vh-form-item :label="$t('host.k_577010')" required>
          <vh-upload
            :headers="headersVo"
            :action="action"
            :show-file-list="false"
            name="resfile"
            :before-upload="beforeUpload"
            :data="{
              path: `${roomId}/img`,
              type: 'image',
              interact_token: interactToken
            }"
            accept=".jpg, .jpeg, .png, .bmp, .gif"
            :on-success="uploadSuccess"
          >
            <div class="create-prize_box" v-if="prizeForm.award_img_url">
              <div class="prize-picture">
                <img :src="prizeForm.award_img_url" alt="" />
              </div>
              <div class="prize-view">
                <span>
                  <i class="vh-iconfont vh-a-line-counterclockwiserotation"></i>
                  <br />
                  {{ $t('host.k_577008') }}
                </span>
                <span @click.stop.prevent="deleteImg">
                  <i class="vh-iconfont vh-line-delete"></i>
                  <br />
                  {{ $t('host.k_577011') }}
                </span>
              </div>
            </div>
            <div class="prize-plus" v-else>
              <span><i class="vh-iconfont vh-a-line-cloudtoupload"></i></span>
              <p>{{ $t('host.k_577012') }}</p>
              <p>{{ $t('host.k_577013') }}</p>
            </div>
          </vh-upload>
        </vh-form-item>
        <vh-form-item :label="$t('host.k_577014')" prop="award_name">
          <vh-input
            v-model="prizeForm.award_name"
            :maxlength="10"
            autocomplete="off"
            show-word-limit
          ></vh-input>
        </vh-form-item>

        <vh-form-item :label="$t('host.k_577015')" prop="award_desc">
          <vh-input
            type="textarea"
            v-model="prizeForm.award_desc"
            autocomplete="off"
            :maxlength="70"
            :rows="4"
            show-word-limit
          ></vh-input>
        </vh-form-item>
        <vh-form-item :label="$t('host.k_577016')" prop="quantity">
          <vh-input v-model.number="prizeForm.quantity" autocomplete="off"></vh-input>
        </vh-form-item>
      </vh-form>
      <span slot="footer">
        <vh-button
          size="medium"
          type="primary"
          v-preventReClick
          @click="surePrize"
          round
          :disabled="
            !(
              prizeForm.quantity &&
              prizeForm.award_name &&
              prizeForm.award_name.length <= 10 &&
              (prizeForm.award_type == 0 ||
                (prizeForm.award_type == 1 && prizeForm.coupon_id) ||
                prizeForm.award_type === 3)
            )
          "
        >
          {{ $t('host.k_577017') }}
        </vh-button>
        <vh-button
          size="medium"
          type="info"
          plain
          @click.prevent.stop="dialogVisible = false"
          round
        >
          {{ $t('host.k_577018') }}
        </vh-button>
      </span>
    </vh-dialog>
    <!-- 是否同步资料库 -->
    <vh-dialog
      :title="$t('host.k_577019')"
      :visible.sync="dialogTongVisible"
      :close-on-click-modal="false"
      :show-close="false"
      :modal="false"
      class="zdy-async-dialog"
      width="400px"
    >
      <div class="async__body">
        <div class="async__ctx">
          <p>{{ $t('host.k_577020') }}</p>
          <vh-checkbox v-model="sureChecked">{{ $t('host.k_577021') }}</vh-checkbox>
        </div>
        <div class="dialog-footer">
          <vh-button type="primary" size="medium" v-preventReClick @click="sureMaterialPrize" round>
            {{ $t('host.k_577017') }}
          </vh-button>
          <vh-button size="medium" type="info" plain @click="cancelMaterialPrize" round>
            {{ $t('host.k_577018') }}
          </vh-button>
        </div>
      </div>
    </vh-dialog>
    <!-- 资料库 -->
    <vh-dialog
      :title="$t('host.k_577022')"
      :visible.sync="dialogPrizeVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :modal="false"
      width="588px"
    >
      <div class="material-prize">
        <div class="material-prize_search" v-show="total || isSearch">
          <vh-input
            v-model="keyword"
            :placeholder="$t('host.k_577023')"
            style="width: 220px"
            @keyup.enter.native="inputChange"
            @clear="inputChange"
            clearable
          >
            <i
              slot="prefix"
              class="vh-icon-search vh-input__icon"
              @click="inputChange"
              style="cursor: pointer; line-height: 36px"
            ></i>
          </vh-input>
        </div>
        <div v-show="total" class="material-prize_list">
          <vh-scrollbar style="height: 100%" v-loadMore="moreLoadData">
            <div class="material-prize_wrapper">
              <div
                class="material-item"
                v-for="(item, index) in prizeList"
                :key="index"
                :class="item.isChecked ? 'active' : ''"
                @click.stop="choosePrize(item)"
              >
                <span class="material-img"><img :src="item.award_img_url" alt="" /></span>
                <div class="material-title">
                  <h1>{{ item.award_name }}</h1>
                  <h1>{{ item.awardTypeDesc }}</h1>
                  <!-- <p>{{ item.prize_id }}</p> -->
                </div>
                <label class="material-tangle" v-show="item.isChecked">
                  <img src="../../img/icon-choose.png" alt="" />
                </label>
              </div>
            </div>
          </vh-scrollbar>
        </div>
        <div class="no-live" v-show="!total">
          <span class="null-img"><img src="../../img/no-file.png" alt="" /></span>
          <p>{{ $t('host.k_577024') }}</p>
          <vh-button type="primary" round @click="createPrize">{{ $t('host.k_577025') }}</vh-button>
        </div>
        <div class="material-prize_footer">
          <div class="material-check" v-show="total || isSearch">
            <i18n path="host.k_577026" tag="span">
              <b>{{ checkedList.length }}</b>
            </i18n>
          </div>
          <div class="material-footer" v-show="total || isSearch">
            <vh-button
              size="medium"
              type="primary"
              @click="sureChoosePrize"
              v-preventReClick
              round
              :disabled="!checkedList.length"
            >
              {{ $t('host.k_577017') }}
            </vh-button>
            <vh-button
              size="medium"
              type="info"
              plain
              @click.prevent.stop="dialogPrizeVisible = false"
              v-preventReClick
              round
            >
              {{ $t('host.k_577018') }}
            </vh-button>
          </div>
        </div>
      </div>
    </vh-dialog>
    <ChoseCoupon
      ref="choseCoupon"
      choseType="radio"
      scene="lottery"
      @selected="selectedCoupon"
    ></ChoseCoupon>
  </div>
</template>
<script>
  import { useRoomBaseServer, useLotteryServer } from 'middle-domain';
  import regRule from '@/app-shared/utils/reg-rule.js';
  import ChoseCoupon from './chose-coupon.vue';
  export default {
    name: 'createLotteryPrize',
    data() {
      return {
        award_type_desc: {
          0: this.$t('host.k_577003'),
          1: this.$t('host.k_577004'),
          3: this.$t('host.k_577005')
        },
        dialogVisible: false,
        dialogPrizeVisible: false,
        dialogTongVisible: false,
        sureChecked: true,
        isSearch: false,
        title: this.$t('host.k_577027'),
        keyword: '',
        prizeList: [],
        checkedList: [],
        prizeForm: {
          award_img_url: '',
          award_name: '',
          quantity: '',
          award_desc: '',
          award_type: 0,
          coupon_id: '',
          coupon_name: '',
          third_lottery_id: ''
        },
        prizeFormCache: {
          0: {
            // 自定义奖品
            award_img_url: '',
            award_name: '',
            quantity: '',
            award_desc: '',
            award_type: 0
          },
          1: {
            // 优惠券奖品
            award_img_url: '',
            award_name: '',
            quantity: '',
            award_desc: '',
            award_type: 1,
            coupon_id: '',
            coupon_name: ''
          },
          3: {
            // 三方奖品
            award_img_url: '',
            award_name: '',
            quantity: '',
            award_desc: '',
            award_type: 3,
            third_lottery_id: ''
          }
        },
        prizePageInfo: {
          pos: 0,
          limit: 10,
          page: 1
        },
        total: 0,
        prizeId: '',
        rules: {
          award_name: [{ required: true, message: this.$t('host.k_577023'), trigger: 'blur' }],
          quantity: [{ required: true, message: this.$t('host.k_577028'), trigger: 'blur' }]
        },
        action: `${process.env.VUE_APP_BASE_URL}/v3/commons/upload/index`
        // cacheType0: {
        //   award_img_url: '',
        //   award_name: '',
        //   quantity: '',
        //   award_desc: '',
        //   award_type: 0,
        //   coupon_id: '',
        //   coupon_name: ''
        // },
        // cacheType1: {
        //   award_img_url: '',
        //   award_name: '',
        //   quantity: '',
        //   award_desc: '',
        //   award_type: 0,
        //   coupon_id: '',
        //   coupon_name: ''
        // }
      };
    },
    components: {
      ChoseCoupon
    },
    beforeCreate() {
      this.lotteryServer = useLotteryServer({
        mode: 'live'
      });
      this.roomBaseServer = useRoomBaseServer();
    },
    created() {
      const { watchInitData } = useRoomBaseServer().state;
      this.roomId = watchInitData?.interact?.room_id;
      this.interactToken = watchInitData?.interact?.interact_token;
      this.headToken = localStorage.getItem('token');
      this.grayId = sessionStorage.getItem('initGrayId') || '';
    },
    computed: {
      // 当前用户角色 1-主持人 2-观众(发起端没有观众) 3-助理；4-嘉宾（互动直播才有嘉宾）
      roleName() {
        return this.roomBaseServer.state.watchInitData.join_info.role_name;
      },
      headersVo: function () {
        const vo = {
          // 助理&嘉宾端不传token
          token: this.roleName == 3 || this.roleName == 4 ? '' : this.headToken,
          platform: 7,
          'gray-id': this.grayId
        };
        return vo;
      }
    },
    methods: {
      // 创建奖品弹窗
      openCreatePrize(title, info) {
        // this.cacheType0 = {
        //   award_img_url: '',
        //   award_name: '',
        //   quantity: '',
        //   award_desc: '',
        //   award_type: 0,
        //   coupon_id: '',
        //   coupon_name: ''
        // };
        // this.cacheType1 = {
        //   award_img_url: '',
        //   award_name: '',
        //   quantity: '',
        //   award_desc: '',
        //   award_type: 0,
        //   coupon_id: '',
        //   coupon_name: ''
        // };
        this.dialogVisible = true;
        this.dialogPrizeVisible = false;
        this.dialogTongVisible = false;
        this.sureChecked = true;
        this.title = title;
        this.$refs.prizeForm?.resetFields();
        if (title === this.$t('host.k_577029')) {
          this.prizeId = info.award_id;
          this.prizeForm = { ...info };
          this.prizeForm.award_type = parseInt(info.award_type + '');
          if (this.prizeForm.award_type == 1) {
            //优惠券奖品
            this.$nextTick(() => {
              this.getCouponInfo();
            });
          } else {
            // this.cacheType0 = this.prizeForm;
            this.prizeFormCache[this.prizeForm.award_type] = this.prizeForm;
          }
        } else {
          this.prizeId = '';
          this.prizeForm = {
            award_img_url: '',
            award_name: '',
            quantity: '',
            award_desc: '',
            award_type: 0,
            coupon_id: '',
            coupon_name: '',
            third_lottery_id: ''
          };
          this.prizeFormCache = {
            0: {
              // 自定义奖品
              award_img_url: '',
              award_name: '',
              quantity: '',
              award_desc: '',
              award_type: 0
            },
            1: {
              // 优惠券奖品
              award_img_url: '',
              award_name: '',
              quantity: '',
              award_desc: '',
              award_type: 1,
              coupon_id: '',
              coupon_name: ''
            },
            3: {
              // 三方奖品
              award_img_url: '',
              award_name: '',
              quantity: '',
              award_desc: '',
              award_type: 3,
              third_lottery_id: ''
            }
          };
        }
      },
      getCouponInfo() {
        this.lotteryServer
          .getCouponInfo({
            coupon_id: this.prizeForm.coupon_id
          })
          .then(res => {
            if (res.code == 200) {
              this.$set(this.prizeForm, 'coupon_name', res.data.coupon_name || '');
              // this.cacheType1 = this.prizeForm;
              this.prizeFormCache[this.prizeForm.award_type] = this.prizeForm;
            }
          });
      },
      // 资料库弹窗
      openPrizeMaterial() {
        this.dialogVisible = false;
        this.dialogPrizeVisible = true;
        this.dialogTongVisible = false;
        this.resetPrizeInfo();
        this.keyword = '';
        this.getPrizeList();
      },
      beforeUpload(file) {
        const typeList = ['jpg', 'png', 'jpeg', 'bmp', 'gif'];
        let typeArr = file.type.toLowerCase().split('/');
        const isType = typeList.includes(typeArr[typeArr.length - 1]);
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isType) {
          this.$message.warning(this.$t('host.k_577030'));
          return false;
        }
        if (!isLt2M) {
          this.$message.warning(this.$t('other.other_1004'));
          return false;
        }
        return isType && isLt2M;
      },
      uploadSuccess(res, file) {
        console.log(res, file);
        if (res.code === 200) {
          this.prizeForm.award_img_url = res.data.domain_url;
        } else {
          this.$message.error(this.$tec(res.code), this.$t('host.k_577031'));
        }
      },
      deleteImg() {
        this.prizeForm.award_img_url = '';
      },
      getPrizeList(search) {
        let formParams = {
          keyword: this.keyword,
          ...this.prizePageInfo,
          source: 1
        };
        this.isSearch = search ? true : false;
        this.lotteryServer.materialPrizeList(formParams).then(res => {
          let adList = res.data.list;

          // award_type:"0"
          // create_time:"2024-05-27 11:46:56"
          // img_path: "https://t-alistatic01.e.vhall.com/upload/lss_c9a3938c/img/71/9c/719cfcf1393ffe01a8e573df8c586b8a5779.png"
          // prize_desc:"2"
          // prize_id:"259155"
          // prize_name:"1"
          // third_lottery_id:""
          adList.map(item => {
            item.award_img_url = item.img_path;
            item.award_name = item.prize_name;
            item.award_id = item.prize_id;
            item.isChecked = false;
            item.awardTypeDesc = this.award_type_desc[item.award_type];
          });
          this.prizeList.push(...adList);
          this.total = res.data.count;
        });
      },
      surePrize() {
        if (
          !(
            this.prizeForm.quantity &&
            this.prizeForm.award_name &&
            (this.prizeForm.award_type == 0 ||
              (this.prizeForm.award_type == 1 && this.prizeForm.coupon_id) ||
              this.prizeForm.award_type === 3)
          )
        ) {
          return;
        }
        if (this.prizeForm.award_type == 1 && !this.prizeForm.coupon_id) {
          this.$message.error(this.$t('host.k_577032'));
          return;
        }
        if (!this.prizeForm.award_img_url) {
          this.$message.error(this.$t('host.k_577033'));
          return;
        }
        const pattern = regRule.positiveInt0; // 非0正整数的正则表达式
        let value = this.prizeForm.quantity;
        if (!value || !pattern.test(value)) {
          this.$message.error(this.$t('host.k_577034'));
          return;
        }

        this.$refs.prizeForm.validate(valid => {
          if (valid) {
            if (
              this.title === this.$t('host.k_577027') &&
              this.$domainStore.state.roomBaseServer.configList?.hidden_asset_library != 1 &&
              [0, 3].includes(this.prizeForm.award_type)
            ) {
              // 是否同步资料库
              this.dialogTongVisible = true;
            } else {
              // 编辑直接保存
              this.liveSurePrize(0);
            }
          } else {
            return false;
          }
        });
      },
      handleClose() {
        this.dialogPrizeVisible = false;
        this.resetPrizeInfo();
      },
      resetPrizeInfo() {
        this.checkedList = [];
        this.prizeList = [];
        this.prizePageInfo = {
          pos: 0,
          limit: 10,
          page: 1
        };
      },
      createPrize() {
        let prizeTotal = this.lotteryServer.state.prizeTotal;
        if (Number(prizeTotal) > 20) {
          this.$message.error(this.$t('host.k_577035'));
          return;
        }
        this.openCreatePrize(this.$t('host.k_577036'));
        this.dialogPrizeVisible = false;
      },
      inputChange() {
        this.resetPrizeInfo();
        if (this.keyword) {
          this.getPrizeList('search');
        } else {
          this.getPrizeList();
        }
      },
      moreLoadData() {
        if (this.prizeList.length >= this.total) {
          return false;
        }
        this.prizePageInfo.page++;
        this.prizePageInfo.pos = parseInt((this.prizePageInfo.page - 1) * this.prizePageInfo.limit);
        this.getPrizeList();
      },
      // 直播间创建奖品
      liveSurePrize(index) {
        let params = {
          share_to_library: index,
          award_id: this.prizeId || undefined,
          ...this.prizeForm
        };
        this.lotteryServer
          .createLivePrize(params)
          .then(res => {
            if (res.code === 200) {
              this.dialogVisible = false;
              this.$message.success(
                this.$t('host.k_577037', [
                  this.title === this.$t('host.k_577029')
                    ? this.$t('host.k_577038')
                    : this.$t('host.k_577036')
                ])
              );
              this.$emit('getTableList');
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(e => {
            this.$message.error(e.msg);
          });
      },
      sureMaterialPrize() {
        if (this.sureChecked) {
          this.liveSurePrize(1);
          this.dialogTongVisible = false;
        } else {
          // 不保存资料库
          this.liveSurePrize(0);
          this.dialogTongVisible = false;
        }
        this.$refs.prizeForm.resetFields();
      },
      cancelMaterialPrize() {
        this.dialogTongVisible = false;
        this.liveSurePrize(0);
      },
      choosePrize(item) {
        item.isChecked = !item.isChecked;
        this.checkedList = this.prizeList
          .filter(items => items.isChecked)
          .map(item => item.award_id);
      },
      sureChoosePrize() {
        let prizeTotal = this.lotteryServer.state.prizeTotal;
        if (prizeTotal + this.checkedList.length > 20) {
          this.$message.error(this.$t('host.k_577035'));
          return;
        }
        let params = {
          award_ids: this.checkedList.join(',')
        };
        this.lotteryServer
          .selectMateriaPrize(params)
          .then(res => {
            if (res.code === 200) {
              this.dialogPrizeVisible = false;
              this.$message.success(this.$t('host.k_577039'));
              this.handleClose();
              this.$emit('getTableList');
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(e => {
            this.$message.error(e.msg);
          });
      },
      selectedCoupon(res) {
        console.log(res);
        if (res.length !== 0) {
          let data = res[0];
          if (!this.prizeForm.award_desc) {
            this.$set(this.prizeForm, 'award_desc', data.use_desc.substring(0, 70) || '');
          }
          if (!this.prizeForm.award_name) {
            this.$set(
              this.prizeForm,
              'award_name',
              data.coupon_name ? data.coupon_name.substring(0, 10) : ''
            );
          }
          this.$set(this.prizeForm, 'coupon_name', data.coupon_name || '');
          this.$set(this.prizeForm, 'coupon_id', data.coupon_id || '');
        }
      },
      changeType(val) {
        // if (this.prizeForm.award_type == 1) {
        //   //优惠券奖品
        //   this.cacheType0 = this.prizeForm;
        //   this.prizeForm = this.cacheType1;
        //   this.prizeForm.award_type = 1;
        // } else {
        //   this.cacheType1 = this.prizeForm;
        //   this.prizeForm = this.cacheType0;
        //   this.prizeForm.award_type = 0;
        // }

        if (val + '' === '3') {
          this.$set(this.rules, 'third_lottery_id', [
            { required: true, message: this.$t('host.k_577040'), trigger: 'blur' }
          ]);
        } else {
          delete this.rules.third_lottery_id;
        }
        this.prizeForm = this.prizeFormCache[val];
        this.prizeForm.award_type = val;
        this.$nextTick(() => {
          this.$refs.prizeForm.clearValidate();
        });
      },
      choseCoupon() {
        this.$refs.choseCoupon.open();
      }
    }
  };
</script>
<style lang="less">
  .live-create-prize {
    .create-prize {
      .vh-upload {
        width: 100%;
        height: 138px;
        line-height: unset;
        overflow: hidden;
        background-color: #f7f7f7;
        border: 1px solid #ccc;
        border-radius: 4px;
      }
      &_box {
        width: 100%;
        height: 100%;
        display: table;
        position: relative;
        &:hover {
          .prize-view {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            line-height: 20px;
          }
        }
      }
      .prize-picture {
        width: 231px;
        height: 138px;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
        }
      }
      .prize-view {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(#000, 0.7);
        display: none;
        span {
          font-size: 12px;
          color: #fff;
          padding: 0 8px;
        }
      }
      .prize-plus {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        span {
          i {
            font-size: 36px;
            color: #999;
          }
        }
        p {
          color: #999;
          font-size: 14px;
          line-height: 20px;
        }
      }

      .couponInfo {
        display: flex;
        align-items: center;
        .coupon {
          margin-right: 10px;
          max-width: 250px;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          white-space: nowrap;
        }
        .highLight {
          color: #3562fa;
          cursor: pointer;
        }
      }
      .vh-textarea .vh-input__count {
        line-height: 20px;
      }

      .vh-dialog__body {
        max-height: 420px;
        overflow-y: auto;
        padding: 0 32px 10px;
        box-sizing: content-box;
        .vh-form-item:last-of-type {
          margin-bottom: 0;
        }
      }
      .vh-dialog__footer {
        padding: 14px 32px 24px;
      }
    }
    .material-prize {
      height: 100%;
      &_search {
        margin-bottom: 16px;
        // padding: 0 32px;
        .vh-input__inner {
          border-radius: 20px;
          height: 36px;
          background: transparent;
        }
      }
      &_list {
        height: 300px;
        margin-bottom: 10px;
      }
      &_wrapper {
        max-height: 300px;
        display: flex;
        // padding: 0 32px;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        .material-item {
          width: 256px;
          height: 96px;
          display: flex;
          background: #f7f7f7;
          margin-bottom: 12px;
          border-radius: 4px;
          cursor: pointer;
          position: relative;
          border: 1px solid transparent;
          transition: all 0.15s ease-in;
          .material-img {
            display: inline-block;
            width: 72px;
            height: 72px;
            margin: 12px;
            border: 1px solid #e6e6e6;
            border-radius: 4px;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
            border-radius: 4px;
          }
          .material-title {
            margin-top: 15px;
            margin-bottom: 15px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            h1 {
              font-weight: 400;
              font-size: 14px;
              color: #1a1a1a;
              line-height: 30px;
            }
            p {
              color: #666;
              // line-height: 30px;
            }
          }
          &:hover {
            box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.02);
          }
          &.active {
            background: #ffffff;
            box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.02);
            border: 1px solid #fb3a32;
          }
          .material-tangle {
            position: absolute;
            right: -1px;
            top: -1px;
            width: 20px;
            height: 20px;
            font-size: 0;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .no-live {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .null-img {
          display: inline-block;
          width: 80px;
          height: 80px;
          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }
        p {
          padding: 10px 0;
        }
      }
      &_footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 24px 0 0;
        .material-check {
          span {
            color: #666;
            b {
              color: #fb3a32;
            }
          }
        }
      }
    }

    .zdy-async-dialog {
      .async__body {
        padding: 0 32px;
      }
      .async__ctx {
        padding: 12px 0;
        p {
          font-size: 14px;
          font-weight: 400;
          color: #1a1a1a;
          line-height: 20px;
          margin-bottom: 8px;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
        }
        .vh-checkbox {
          .vh-checkbox__label {
            font-size: 14px;
            font-weight: 400;
            color: #1a1a1a;
            line-height: 20px;
            padding-left: 8px;
          }
        }
      }
    }
  }
</style>
